
import React from 'react';
import { Link } from 'react-router-dom';
import { Settings, LayoutDashboard } from 'lucide-react';

interface MobileMenuNavLinksProps {
  onClose: () => void;
}

const MobileMenuNavLinks = ({ onClose }: MobileMenuNavLinksProps) => {
  return (
    <div className="p-3">
      {/* Settings */}
      <Link
        to="/settings"
        className="flex items-center gap-3 p-3 mb-4 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        onClick={onClose}
      >
        <Settings className="h-5 w-5 text-gray-700 dark:text-gray-300" />
        <span className="text-sm font-medium text-gray-800 dark:text-gray-200">Settings</span>
      </Link>
      
      <div className="border-t border-gray-200 dark:border-gray-700 mb-3"></div>
      
      <Link
        to="/dashboard"
        className="flex items-center gap-3 p-3 rounded-lg bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-colors"
        onClick={onClose}
      >
        <LayoutDashboard className="h-5 w-5" />
        <span className="text-sm font-medium">Dashboard</span>
      </Link>
    </div>
  );
};

export default MobileMenuNavLinks;
